import OfferPageDispatchContext from 'contexts/OfferPage/offerPageDispatchContext'
import { useContext } from 'react'

export default function useOfferPageDispatch() {
  const dispatch = useContext(OfferPageDispatchContext)
  return dispatch
}
